
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/schools/our-services/thank-you",
      function () {
        return require("private-next-pages/schools/our-services/thank-you/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/schools/our-services/thank-you"])
      });
    }
  